var _rect, _rect2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinishedStep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 19,
    fill: "url(#paint0_linear_4273_4384)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "#FFBB00",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3065 11.2074C19.5339 10.8116 19.6477 10.6136 19.7963 10.5473C19.926 10.4894 20.0742 10.4894 20.2038 10.5473C20.3525 10.6136 20.4662 10.8116 20.6937 11.2074L22.6489 14.6097C22.7331 14.7563 22.7752 14.8296 22.8342 14.8828C22.8865 14.9299 22.948 14.9655 23.015 14.9871C23.0906 15.0117 23.1751 15.0115 23.3441 15.0111L27.2682 15.0032C27.7248 15.0023 27.953 15.0018 28.0848 15.0974C28.1998 15.1808 28.2738 15.3091 28.2886 15.4503C28.3054 15.6122 28.1909 15.8097 27.9618 16.2046L25.9929 19.599C25.9081 19.7452 25.8657 19.8183 25.8491 19.896C25.8344 19.9648 25.8344 20.0359 25.8491 20.1047C25.8657 20.1825 25.9081 20.2556 25.9929 20.4018L27.9618 23.7962C28.1909 24.1911 28.3054 24.3886 28.2886 24.5505C28.2738 24.6917 28.1998 24.82 28.0848 24.9034C27.953 24.999 27.7248 24.9985 27.2682 24.9976L23.3441 24.9896C23.1751 24.9893 23.0906 24.9891 23.015 25.0136C22.948 25.0353 22.8865 25.0709 22.8342 25.118C22.7752 25.1712 22.7331 25.2445 22.6489 25.391L20.6937 28.7934C20.4662 29.1892 20.3525 29.3871 20.2038 29.4535C20.0742 29.5113 19.926 29.5113 19.7963 29.4535C19.6477 29.3871 19.5339 29.1892 19.3064 28.7934L17.3513 25.391C17.2671 25.2445 17.225 25.1712 17.1659 25.118C17.1137 25.0709 17.0521 25.0353 16.9852 25.0136C16.9096 24.9891 16.825 24.9893 16.656 24.9896L12.732 24.9976C12.2754 24.9985 12.0471 24.999 11.9153 24.9034C11.8004 24.82 11.7263 24.6917 11.7116 24.5505C11.6947 24.3886 11.8092 24.1911 12.0383 23.7962L14.0072 20.4018C14.092 20.2556 14.1344 20.1825 14.151 20.1047C14.1657 20.0359 14.1657 19.9648 14.151 19.896C14.1344 19.8183 14.092 19.7452 14.0072 19.599L12.0383 16.2046C11.8092 15.8097 11.6947 15.6122 11.7116 15.4503C11.7263 15.3091 11.8004 15.1808 11.9153 15.0974C12.0471 15.0018 12.2754 15.0023 12.732 15.0032L16.656 15.0111C16.825 15.0115 16.9096 15.0117 16.9852 14.9871C17.0521 14.9655 17.1137 14.9299 17.1659 14.8828C17.225 14.8296 17.2671 14.7563 17.3513 14.6097L19.3065 11.2074Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4273_4384",
    x1: 20,
    y1: -0.00000119209,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E63535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CC0D0E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishedStep);
export default __webpack_public_path__ + "static/media/finished_step.bc4821c2ad1f5f9b6ff5a77b3aacdd0c.svg";
export { ForwardRef as ReactComponent };